const AccessControlPermissionAction = {
    READ: 'READ',
    WRITE: 'WRITE',
};

export default AccessControlPermissionAction;
